<template>
  <v-card :loading="loading" class="newsTable">
    <v-card-text>
      <v-data-table
        :items="news"
        item-key="id"
        :headers="columns"
        hide-default-header
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Новости</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="newArticle">
              Добавить
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item, index }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="checkRemove(item)"> mdi-delete </v-icon>
          <v-btn
            icon
            class="buttonUp"
            title="поставить раньше"
            @click="moveItem(item, 'up')"
          >
            <v-icon small> mdi-arrow-up-thin-circle-outline </v-icon>
          </v-btn>
          <v-btn
            icon
            class="buttonDown"
            title="поставить позже"
            @click="moveItem(item, 'down')"
          >
            <v-icon small> mdi-arrow-down-thin-circle-outline </v-icon>
          </v-btn>
          <v-btn
            v-if="!item.show"
            icon
            color="secondary"
            small
            title="скрыто (нажмите, чтобы показывать)"
            @click="toggle(item)"
          >
            <v-icon small>mdi-eye-off</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            color="light-blue"
            small
            title="показывается на сайте (нажмите, чтобы скрыть)"
            @click="toggle(item)"
          >
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Удаление</span>
          </v-card-title>
          <v-card-text>
            Вы действительно хотите удалить эту новость? Данное действие
            необратимо!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteDialog = false">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="remove"> Удалить </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NewsTable",
  props: {
    news: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          text: "Новость",
          align: "start",
          value: "title_ru"
        },
        { text: "Действия", value: "actions", align: "end", sortable: false }
      ],
      deleteItem: null,
      deleteDialog: false
    };
  },
  methods: {
    newArticle() {
      this.$emit("create");
    },
    editItem(article) {
      this.$emit("read", article);
    },
    checkRemove(article) {
      this.deleteItem = article;
      this.deleteDialog = true;
    },
    remove() {
      this.$emit("delete", this.deleteItem);
      this.deleteDialog = false;
    },
    moveItem(article, dir) {
      this.$emit("move", article, dir);
    },
    toggle(article) {
      this.$emit("toggle", article);
    }
  }
};
</script>
<style lang="scss">
.newsTable {
  tr:first-child .buttonUp,
  tr:last-child .buttonDown {
    display: none;
    pointer-events: none;
  }
}
</style>
